
import { defineComponent, PropType } from 'vue'

// @types
import { PredictionCar } from '@/new-services/types/prediction'

// @icons
import carPassenger from '@/assets/icons/car_passenger.svg'
import carTruck from '@/assets/icons/car_truck.svg'

export default defineComponent({
    components: {
        carPassenger,
        carTruck,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        cars: {
            type: Array as PropType<PredictionCar[]>,
            default: () => [],
        },
    },
    setup(props) {
        const getStopsCount = (car_type: string) => {
            if (!props.cars.length) return 0

            if (car_type === 'P') {
                return props.cars.reduce(
                    (sum, car) => (sum += car ? car.passanger.stopsCount : 0),
                    0
                )
            } else if (car_type === 'T') {
                return props.cars.reduce((sum, car) => (sum += car ? car.truck.stopsCount : 0), 0)
            }
        }
        const getCarCount = (car_type: string) => {
            if (!props.cars.length) return 0

            if (car_type === 'P') {
                return props.cars.reduce((sum, car) => (sum += car ? car.passanger.carCount : 0), 0)
            } else if (car_type === 'T') {
                return props.cars.reduce((sum, car) => (sum += car ? car.truck.carCount : 0), 0)
            }
        }
        const getWeight = (car_type: string) => {
            if (!props.cars.length) return 0

            if (car_type === 'P') {
                return props.cars.reduce((sum, car) => (sum += car ? car.passanger.weight : 0), 0)
            } else if (car_type === 'T') {
                return props.cars.reduce((sum, car) => (sum += car ? car.truck.weight : 0), 0)
            }
        }
        const getVolumeWeight = (car_type: string) => {
            if (!props.cars.length) return 0

            if (car_type === 'P') {
                return props.cars.reduce(
                    (sum, car) => (sum += car ? car.passanger.volumeWeight : 0),
                    0
                )
            } else if (car_type === 'T') {
                return props.cars.reduce((sum, car) => (sum += car ? car.truck.volumeWeight : 0), 0)
            }
        }

        return {
            getStopsCount,
            getCarCount,
            getWeight,
            getVolumeWeight,
        }
    },
})
